import { CODE_FILE_DEL, CODE_FILE_DET, CODE_FILE_SAVE } from "../actions/action-types";
import { initialSTateDatasData, initialStateNext } from "../helpers";

// Détail d'un fichier
export function DetailFileReducer(state = initialSTateDatasData, action) {
    switch (action.type) {
        case CODE_FILE_DET:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Sauvegarde d'un fichier
export function SaveFileReducer(state = initialStateNext, action) {
    switch (action.type) {
        case CODE_FILE_SAVE:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Suppression d'un fichier
export function DeleteFileReducer(state = initialStateNext, action) {
    switch (action.type) {
        case CODE_FILE_DEL:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}
